module.exports = __webpack_public_path__ + "static/img/3.f32f9c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/3.png
// module id = K8+o
// module chunks = 0